import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./theme/global.css";
import "react-toastify/dist/ReactToastify.css";
import { KeycloakProvider } from "./modules/auth/context/KeycloakContext";
import { PermissionsProvider } from "./context/PermissionsProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <KeycloakProvider>
      <PermissionsProvider>
        <App />
      </PermissionsProvider>
    </KeycloakProvider>
  </React.StrictMode>,
);